<template>
  <fragment>
    <search-nav-item-select label="연도" v-model="nav.searchYear" :list="searchYears" name="searchYear" />
    <search-nav-item-select label="반기" v-model="nav.halfYear" :list="halfYears" name="halfYear" />
    <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="searchTypes" name="searchType" />
    <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword" />
  </fragment>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import { getFieldLabel } from "@/util/DataUtil";

export default {
  name: "NormalSearchNav570",
  components: {
    SearchNav,
    SearchNavItemKeyword,
    SearchNavItemSelect,
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler() {
        this.$emit("input", this.nav);
      },
    },
  },
  computed: {
    searchYears() {
      const years = [];
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i >= 2010; i--) {
        years.push({ value: i });
      }
      return [{ text: "전체", value: "" }, ...years];
    },
  },
  data() {
    return {
      nav: {
        searchYear: "",
        halfYear: "",
        searchType: "",
        searchKeyword: "",
      },
      halfYears: [{ text: "전체", value: "" }, { value: "상반기" }, { value: "하반기" }],
      searchTypes: [{ value: "지역" }, { value: "급별" }, { value: "학교(기관)명" }, { value: "이름" }, { value: "직종" }, { value: "이수여부" }, { value: "작성자" }],
    };
  },
};
</script>

<style scoped></style>
